export default __webpack_public_path__ + "static/media/in-food-exchange-novotel-hyderabad-convention-centre.0e615ba1.jpg";